module.exports = __webpack_public_path__ + "img/icon-sm-gray.205f3641.svg";